// Aviso de período curto: a primeira atividade (primeiro pedido) cai DENTRO do período escolhido,
// então os números cobrem só parte dele e não há período anterior comparável.

const SAO_PAULO_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Sao_Paulo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Dia civil de São Paulo (yyyy-MM-dd) de um instante ISO; null se a data não for válida. */
function saoPauloDay(iso: string): string | null {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : SAO_PAULO_DAY.format(date);
}

/**
 * Data da primeira atividade formatada (dd/MM/yyyy) quando ela cai dentro do período
 * (from/to em yyyy-MM-dd, extremos incluídos). Fora do período, sem data ou sem período: null.
 */
export function shortPeriodStart(
  firstActivityAt: string | null | undefined,
  period: { from?: string; to?: string } | undefined,
): string | null {
  if (!firstActivityAt || !period?.from || !period?.to) return null;

  const day = saoPauloDay(firstActivityAt);
  if (!day || day < period.from || day > period.to) return null;

  const [year, month, date] = day.split('-');
  return `${date}/${month}/${year}`;
}
